<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_ix"></a>This book was written with the good counsel<br/>of<br/>Wendy Mogel and Louis Breger</p>
<p class="textcenter">This book is dedicated<br/>to<br/>Horace Beck and Olga Smyth,<br/>two fine teachers<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_dedi.vue?1ef6e3b1